var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 164.41 164.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:lightgrey;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 166.41,
    height: 166.41
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path11",
    className: "cls-3",
    d: "M99.13,47.1a16.26,16.26,0,1,0,16.26-16.26A16.28,16.28,0,0,0,99.13,47.1Zm5,0a11.26,11.26,0,1,1,11.26,11.27A11.27,11.27,0,0,1,104.13,47.1Zm55,118.31H7.2A6,6,0,0,1,1,159.17V7.2C1.06,4.11,3,1,7.24,1h152a5.91,5.91,0,0,1,6.21,6.24v152a6,6,0,0,1-6.24,6.2Zm-151.93-5H159.18c.65,0,1.21,0,1.23-1.24v-40.6L121.79,96.11,98.41,109.76a3.51,3.51,0,0,1-4.16-.28L45.43,72C43,74.16,14.35,99.61,6,107v52.14C6,159.83,6,160.39,7.24,160.41ZM159.11,6H7.24C6.59,6,6,6,6,7.24v93.15L43.65,66.88a2.51,2.51,0,0,1,3.19-.12L96.63,105l23.89-14a2.5,2.5,0,0,1,2.52,0l37.37,21.76V7.24c0-.65,0-1.21-1.3-1.24Z",
    transform: "translate(-1 -1)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/iconUpload.085fec4e3d4c3fae4965f94e7e601f5f.svg";
export { ForwardRef as ReactComponent };